import styles from "./SvgContainer4.module.css"

const SvgContainer4 = () => {
  return (
    <div className={styles.svgContainer}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1965"
        height="1802"
        viewBox="0 0 1965 1802"
        fill="none"
        className={styles.redSvg}
      >
        <path
          d="M39.8829 1577.15C-87.0694 1567.07 -114.042 1502.96 -111.659 1472.17L-111.659 0L2064.26 0V1472.17C2066.64 1502.96 2039.67 1567.07 1912.72 1577.15C1754.02 1589.74 1758.31 1633.84 1734.01 1669.53C1709.71 1705.22 1671.11 1740.91 1535.29 1712.57C1399.47 1684.23 1266.52 1674.78 1165.01 1741.96C1083.81 1795.72 1005.2 1802 976.3 1802C947.397 1802 868.789 1795.72 787.591 1741.96C686.082 1674.78 553.126 1684.23 417.309 1712.57C281.493 1740.91 242.892 1705.22 218.588 1669.53C194.284 1633.84 198.574 1589.74 39.8829 1577.15Z"
          fill="#1D1534"
        />
        <path
          d="M39.8829 1577.15C-87.0694 1567.07 -114.042 1502.96 -111.659 1472.17L-111.659 0L2064.26 0V1472.17C2066.64 1502.96 2039.67 1567.07 1912.72 1577.15C1754.02 1589.74 1758.31 1633.84 1734.01 1669.53C1709.71 1705.22 1671.11 1740.91 1535.29 1712.57C1399.47 1684.23 1266.52 1674.78 1165.01 1741.96C1083.81 1795.72 1005.2 1802 976.3 1802C947.397 1802 868.789 1795.72 787.591 1741.96C686.082 1674.78 553.126 1684.23 417.309 1712.57C281.493 1740.91 242.892 1705.22 218.588 1669.53C194.284 1633.84 198.574 1589.74 39.8829 1577.15Z"
          fill="url(#paint0_linear_225_16)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_225_16"
            x1="-111.8"
            y1="71.8945"
            x2="2732.91"
            y2="635.538"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ED374D" />
            <stop offset="0.505208" stopColor="#FA793F" />
            <stop offset="1" stopColor="#F7F651" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}

export default SvgContainer4
